module.exports = __webpack_public_path__ + "img/dora-aventureira.9ced6e50.jpg";